import { render, staticRenderFns } from "./AddSobatCategory.vue?vue&type=template&id=5dbc0b0a&scoped=true&"
import script from "./AddSobatCategory.vue?vue&type=script&lang=js&"
export * from "./AddSobatCategory.vue?vue&type=script&lang=js&"
import style0 from "./AddSobatCategory.vue?vue&type=style&index=0&id=5dbc0b0a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc0b0a",
  null
  
)

export default component.exports